import axios from 'axios';
import { API_CONFIG } from './api';

// Crea istanza axios con configurazione base
const createAxiosInstance = (tokenKey, loginRedirect) => {
  const instance = axios.create({
    baseURL: `${API_CONFIG.BASE_URL}/api`,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    withCredentials: true
  });

  // Interceptor: aggiunge token a ogni richiesta
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem(tokenKey);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Interceptor: gestisce 401 (token scaduto), non su richieste di login
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        const requestUrl = error.config?.url || '';
        const isLoginRequest = requestUrl.includes('/login');
        const isOnLoginPage = window.location.pathname.endsWith('/login');

        if (!isLoginRequest && !isOnLoginPage) {
          localStorage.removeItem(tokenKey);
          localStorage.removeItem(tokenKey.replace('_token', '_user'));
          window.location.href = loginRedirect;
        }
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

// Istanza per admin
export const adminApi = createAxiosInstance('admin_token', '/admin/login');

// Istanza per fornitore
export const fornitoreApi = createAxiosInstance('fornitore_token', '/fornitore/login');

// Istanza per cliente
export const clienteApi = createAxiosInstance('cliente_token', '/area-riservata/login');

export default adminApi;
